import { jsx, jsxs } from "react/jsx-runtime";
import { addTheme, replaceTheme } from "@tamagui/theme";
import { useState } from "react";
import {
  Button,
  Square,
  Theme,
  XStack,
  YStack,
  useForceUpdate,
  useIsomorphicLayoutEffect
} from "tamagui";
function ReplaceThemeDemo() {
  const [theme, setTheme] = useState();
  const update = useForceUpdate();
  useIsomorphicLayoutEffect(() => {
    addTheme({
      name: "mytheme",
      insertCSS: true,
      theme: {
        color: "red",
        color2: "green"
      }
    });
    setTheme("mytheme");
  }, []);
  return /* @__PURE__ */ jsxs(YStack, { alignItems: "center", space: true, children: [
    /* @__PURE__ */ jsx(XStack, { gap: "$5", children: /* @__PURE__ */ jsx(Theme, { name: theme ?? null, children: /* @__PURE__ */ jsx(Square, { borderRadius: "$8", size: 100, backgroundColor: "$color" }) }) }),
    /* @__PURE__ */ jsx(
      Button,
      {
        onPress: () => {
          replaceTheme({
            name: "mytheme",
            theme: {
              color: "blue"
            }
          });
          update();
        },
        children: "Replace theme to only have $color: blue"
      }
    )
  ] });
}
export {
  ReplaceThemeDemo
};
//# sourceMappingURL=ReplaceThemeDemo.js.map
